export class StatusCheckerService {

  constructor() {
    this.unknownStatus = {
      name    : 'unknownStatus',
      cssClass: 'icon-dot-circled unknownStatus',
      text: gettext('Нет данных от агента более 10 минут')
    };
    this.onlineStatus = {
      name    : 'onlineStatus',
      cssClass: 'icon-dot-circled onlineStatus',
      text: gettext('Пользователь активен')
    };
    this.awayStatus = {
      name    : 'awayStatus',
      cssClass: 'icon-dot-circled awayStatus',
      text: gettext('Пользователь неактивен более 5 минут')
    };
    const hour = 3600000;
    this.onlineInterval = hour / 12;
    this.awayInterval = hour / 6;
  }

  check(cell) {
    let last_activity_time;
    let last_report_time;
    if (cell['agent_agent.id']) {
      last_activity_time = cell['agent_agent.last_activity_time'];
      last_report_time = cell['agent_agent.last_report_time'];
    }
    if (cell['agent_account.user_name']) {
      last_activity_time = cell['agent_account.last_activity_time'];
      last_report_time = cell['agent_account.last_report_time'];
    }
    if (!last_report_time) {
      return this.unknownStatus;
    }
    const now = new Date();
    if (last_activity_time) {
      const lat_date = new Date(last_activity_time);
      if ((now - lat_date) < this.onlineInterval) {
        return this.onlineStatus;
      }
    }
    const lrt_date = new Date(last_report_time);
    if ((now - lrt_date) < this.awayInterval) {
      return this.awayStatus;
    }
    return this.unknownStatus;
  }
}



// WEBPACK FOOTER //
// ./src/core/status-checker.service.js